"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFilter = void 0;
var react_1 = __importDefault(require("react"));
var SortFilter_module_scss_1 = __importDefault(require("./SortFilter.module.scss"));
var react_redux_1 = require("react-redux");
var sortCarsSlice_1 = require("../../redux/slice/sortCarsSlice");
var react_router_dom_1 = require("react-router-dom");
var SortFilter = function (_a) {
    var isOpen = _a.isOpen, onToggle = _a.onToggle;
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedOption = (0, react_redux_1.useSelector)(sortCarsSlice_1.selectSortOption);
    var sortFilterRef = react_1.default.useRef(null);
    var _b = (0, react_router_dom_1.useSearchParams)(), searchParams = _b[0], setSearchParams = _b[1];
    var initialRenderRef = react_1.default.useRef(true);
    react_1.default.useEffect(function () {
        var _a;
        if (initialRenderRef.current) {
            var sortOption = (_a = Object.entries(sortCarsSlice_1.SORT_OPTIONS).find(function (_a) {
                var value = _a[1];
                return searchParams.get(value.param) === 'true';
            })) === null || _a === void 0 ? void 0 : _a[0];
            if (sortOption) {
                dispatch((0, sortCarsSlice_1.setSortOption)(sortOption));
            }
            else {
                dispatch((0, sortCarsSlice_1.setSortOption)('price_asc'));
                var newParams = new URLSearchParams();
                newParams.set(sortCarsSlice_1.SORT_OPTIONS.price_asc.param, 'true');
                setSearchParams(newParams);
            }
            initialRenderRef.current = false;
        }
    }, [searchParams, dispatch, setSearchParams]);
    var handleOptionClick = function (key) {
        dispatch((0, sortCarsSlice_1.setSortOption)(key));
        var newParams = new URLSearchParams();
        newParams.set(sortCarsSlice_1.SORT_OPTIONS[key].param, 'true');
        setSearchParams(newParams);
        onToggle();
    };
    return (react_1.default.createElement("div", { className: "".concat(SortFilter_module_scss_1.default.sort_filter), ref: sortFilterRef },
        react_1.default.createElement("div", { className: SortFilter_module_scss_1.default.sort_filter__header, onClick: onToggle },
            react_1.default.createElement("span", null, sortCarsSlice_1.SORT_OPTIONS[selectedOption || 'price_desc'].label)),
        isOpen && (react_1.default.createElement("ul", { className: SortFilter_module_scss_1.default.sort_filter__list }, Object.entries(sortCarsSlice_1.SORT_OPTIONS).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (react_1.default.createElement("li", { key: key, className: "".concat(SortFilter_module_scss_1.default.sort_filter__item, " ").concat(key === selectedOption ? SortFilter_module_scss_1.default.active : ''), onClick: function () { return handleOptionClick(key); } }, value.label));
        })))));
};
exports.SortFilter = SortFilter;
